import { useState } from "react";

import Select from "ds/components/Select";
import SelectInput from "ds/components/Select/Input";
import Typography from "ds/components/Typography";
import { AspectType } from "types/generated";

import UsageChart from "../Chart";
import { GroupByKey } from "../Chart/constants";
import CSVDownloadButton from "../CSVDownload/Button";
import UsageLayoutHeader from "../Layout/Header";
import UsageLayoutHeaderActions from "../Layout/Header/Actions";
import { getDefaultTimeFilter } from "../utils";
import { getColorMapper } from "./colorMapper";
import RunMinutesTotals from "./Totals";
import useFilters from "./useFilters";

const GROUP_BY_OPTIONS = [
  { value: GroupByKey.RunType, label: "Run type" },
  { value: GroupByKey.RunState, label: "Run state" },
];

const UsageRunMinutes = () => {
  const { groupBy, setGroupBy } = useFilters();

  const [timeFilter] = useState(getDefaultTimeFilter);

  const colorMapper = getColorMapper(groupBy);

  return (
    <>
      <UsageLayoutHeader title="Current period usage chart">
        <UsageLayoutHeaderActions>
          <Select
            value={groupBy}
            items={GROUP_BY_OPTIONS}
            onChange={setGroupBy}
            renderInput={(props) => (
              <SelectInput {...props}>
                <Typography variant="p-t7" tag="span">
                  Grouped by: {groupBy}
                </Typography>
              </SelectInput>
            )}
          />
          <CSVDownloadButton timeFilter={timeFilter} aspectType={AspectType.RunMinutes} />
        </UsageLayoutHeaderActions>
      </UsageLayoutHeader>
      <RunMinutesTotals timeFilter={timeFilter} />
      <UsageChart
        timeFilter={timeFilter}
        groupBy={groupBy}
        aspectType={AspectType.RunMinutes}
        leftAxisLabel="Minutes"
        colorMapper={colorMapper}
        tooltipHeader="Total minutes:"
        showPercentiles={false}
      />
    </>
  );
};

export default UsageRunMinutes;
